module.exports = __webpack_public_path__ + "static/img/wenhuayishu-2.8ed9e680.svg";